export const KnownDialogs = {
  connect: 'connect',
  successStake: 'successStake',
  successUnstake: 'successUnstake',
  boostRewards: 'boostRewards',
  navigation: 'navigation',
};

export type KnownDialogs = (typeof KnownDialogs)[keyof typeof KnownDialogs];
